import gql from 'graphql-tag'
import { DataProxy } from 'apollo-cache/src/types/DataProxy'
import { WebApi } from '~/utils/webApi'

export const GET_LOCAL_CSRF_TOKEN = gql`
  {
    csrfToken @client
  }
`

export const createWebApi = (cache: DataProxy, monolithUrl?: string) => {
  const res = cache.readQuery<{ csrfToken: string }>({
    query: GET_LOCAL_CSRF_TOKEN,
  })
  return new WebApi(res?.csrfToken, monolithUrl)
}
